export const alertHeaders = [
    {
      "id": "id",
      "disablePadding": true,
      "label": "ID",
      "isFilterable": false,
      "showColumnUnExpanded": false
    },
    {
      "id": "createdDate",
      "disablePadding": false,
      "label": "First Seen",
      "isFilterable": true,
      "isDate": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "latestKeyEvent",
      "disablePadding": false,
      "label": "Last Modified",
      "isFilterable": true,
      "isDate": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "passfail",
      "disablePadding": false,
      "label": "Pass/Fail",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "provider",
      "disablePadding": false,
      "label": "Provider",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "framework",
      "disablePadding": false,
      "label": "Framework",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "rule",
      "disablePadding": false,
      "label": "Rule Name Short",
      "isFilterable": false,
      "showColumnUnExpanded": true,
    },
    {
      "id": "alertname",
      "disablePadding": false,
      "label": "Rule Name Full",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "resourceids",
      "disablePadding": false,
      "label": "Resource IDs",
      "isFilterable": false,
      "showColumnUnExpanded": false
    },
    {
      "id": "classification",
      "disablePadding": false,
      "label": "Classification",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "org",
      "disablePadding": false,
      "label": "Org",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "severity",
      "disablePadding": false,
      "label": "Severity",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "assignedto",
      "disablePadding": false,
      "label": "Assigned to",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "status",
      "disablePadding": false,
      "label": "Status",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "action",
      "disablePadding": false,
      "label": "Action",
      "isFilterable": false,
      "showColumnUnExpanded": true
    }
]

export const userHeaders = [
    {
      "id": "id",
      "disablePadding": true,
      "label": "ID",
      "isFilterable": false,
      "showColumnUnExpanded": false
    },
    {
      "id": "createdDate",
      "disablePadding": false,
      "label": "First Seen",
      "isFilterable": true,
      "isDate": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "latestKeyEvent",
      "disablePadding": false,
      "label": "Last Modified",
      "isFilterable": true,
      "isDate": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "passfail",
      "disablePadding": false,
      "label": "Pass/Fail",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "provider",
      "disablePadding": false,
      "label": "Provider",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "framework",
      "disablePadding": false,
      "label": "Framework",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "rule",
      "disablePadding": false,
      "label": "Rule Name Short",
      "isFilterable": false,
      "showColumnUnExpanded": true,
    },
    {
      "id": "alertname",
      "disablePadding": false,
      "label": "Rule Name Full",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "resourceids",
      "disablePadding": false,
      "label": "Resource IDs",
      "isFilterable": false,
      "showColumnUnExpanded": false
    },
    {
      "id": "classification",
      "disablePadding": false,
      "label": "Classification",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "org",
      "disablePadding": false,
      "label": "Org",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "severity",
      "disablePadding": false,
      "label": "Severity",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "assignedto",
      "disablePadding": false,
      "label": "Assigned to",
      "isFilterable": true,
      "showColumnUnExpanded": false
    },
    {
      "id": "status",
      "disablePadding": false,
      "label": "Status",
      "isFilterable": true,
      "showColumnUnExpanded": true
    },
    {
      "id": "action",
      "disablePadding": false,
      "label": "Action",
      "isFilterable": false,
      "showColumnUnExpanded": true
    },
]